import { Injectable } from '@angular/core';
import { ProductServiceInterface } from '@app/models/interfaces/product-service.interface';
import { TaqmanSearchResponseInterface } from '@app/models/responses/taqman-search-response.interface';
import { MicrornaClassicProductApiInterface } from '@app/products/microrna/microrna-classic/models/interfaces/microrna-classic-product-api.interface';
import { MicrornaClassicProductInterface } from '@app/products/microrna/microrna-classic/models/interfaces/microrna-classic-product.interface';

@Injectable({providedIn: 'root'})
export class MicrornaClassicProductService implements ProductServiceInterface {

    makeProductFromSearchResult(searchResult: TaqmanSearchResponseInterface): MicrornaClassicProductInterface[] {

        return searchResult.products.map((product: MicrornaClassicProductApiInterface) => {

            const newProduct: MicrornaClassicProductInterface = {
                ...product,
                selectedAvailability: product.availability, // preselect
                selectedCatalogNumber: product.defaultCatalogNum, // preselect
                selectedSize: product.defaultSize, // preselect
                taqmanProductID: product.productID // unique ID for the UI
            }

            return newProduct;

        });

    }

}
